<template>

<div class="full-year-stats-wrapper">
<div class="stat-box">
<div class="stats-box-cat">Games</div>
<div class="stats-box-value">{{fullGames}}</div>
</div>
<div class="stat-box-spacer"></div>
<div class="stat-box">
<div class="stats-box-cat">Compl.</div>
<div class="stats-box-value">{{fullCompletions}}</div>
</div>
<div class="stat-box-spacer"></div>
<div class="stat-box">
<div class="stats-box-cat">Att.</div>
<div class="stats-box-value">{{fullAttempts}}</div>
</div>
<div class="stat-box-spacer"></div>
<div class="stat-box">
<div class="stats-box-cat">Pct.</div>
<div class="stats-box-value">{{fullPct}}</div>
</div>
<div class="stat-box-spacer"></div>
<div class="stat-box">
<div class="stats-box-cat">Yards</div>
<div class="stats-box-value">{{fullYards}}</div>
</div>
<div class="stat-box-spacer"></div>
<div class="stat-box">
<div class="stats-box-cat">TD</div>
<div class="stats-box-value">{{fullTDs}}</div>
</div>
<div class="stat-box-spacer"></div>
<div class="stat-box">
<div class="stats-box-cat">INT</div>
<div class="stats-box-value">{{fullINTs}}</div>
</div>
<div class="stat-box-spacer"></div>
<div class="stat-box">
<div class="stats-box-cat">YPG</div>
<div class="stats-box-value">{{fullYPG}}</div>
</div>
<div class="stat-box-spacer"></div>
<div class="stat-box">
<div class="stats-box-cat">Rating</div>
<div class="stats-box-value">{{fullRating}}</div>
</div>
 
</div>
</template>

<script>

export default {
  name: 'FullYearStats',
    props: {
      fullGames: '',
      fullCompletions: '',
      fullAttempts: '',
      fullYards: '',
      fullPct: '',
      fullTDs: '',
      fullINTs: '',
      fullYPG: '',
      fullRating: '',
  },
  data: function () {
    return {

  }
}

}

</script>

<style>

.full-year-stats-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    min-height:100px;
    height:100%;
    border-bottom: 7px solid black;
    border-top: 7px solid black;
    background: black;
    color: white;
}

.stat-box {
  text-align:center;
    font-family: 'Teko', sans-serif;
    font-size: 30px;
    text-transform:uppercase;
    margin-top:15px;

}

.stats-box-cat {
    border-bottom: 3px solid #D3BC8D;
    display:flex;
    justify-content:center;
    align-items:center;
    line-height:30px;
    font-weight: 700;
}

.stats-box-value {
    display:flex;
    justify-content:center;
    align-items:center;
    font-size: 60px;
    line-height: 69px;
}



.stat-box-spacer {
    width: 4px;
    height: 100%;
    min-height: 120px;
    background: #d3bc8c;
    transform: skewX(-12deg);
}

@media(max-width:1023px) {
  .stats-box-value {
    font-size: 34px;
    line-height: 45px;
  }
}


@media (max-width:767px) {

.stat-box-spacer {
  display: none;
}
.stat-box {

}
.stat-box:nth-child(-n+10) {
    width: 20%;
    box-shadow: 0px 0px 45px -11px #00000052;
}

.stat-box:nth-child(n+10) {
width:25%;
box-shadow: 0px 0px 45px -11px #00000052;
}



.stats-box-cat {
    height: 40px;
  
}

.stats-box-value {
    height: 50px;
    font-size: 29px;
}


}



@media (max-width:420px) {

.stat-box {
    font-size: 18px;
    width:18%;
}

}


</style>


// WEBPACK FOOTER //
// src/components/FullYearStats.vue